module.exports = __webpack_public_path__ + "static/Competetive Rates Icon-hover-bacf14264a3a43d63f528aa88858e6d2.svg";